import { render, staticRenderFns } from "./SeabornCrawl.vue?vue&type=template&id=1278cb28&scoped=true&"
import script from "./SeabornCrawl.vue?vue&type=script&lang=js&"
export * from "./SeabornCrawl.vue?vue&type=script&lang=js&"
import style0 from "./SeabornCrawl.vue?vue&type=style&index=0&id=1278cb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278cb28",
  null
  
)

export default component.exports